import React from 'react'
import './text-container.scss'

interface TextContainerProps {
  text: string
  isActive: boolean
}

const TextContainer: React.FC<TextContainerProps> = ({ text, isActive }) => {
  return <span className={`text-container ${isActive ? 'text-container__active' : ''}`}>{text}</span>
}

export default TextContainer
